import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description PopularProfessions icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PopularProfessions } from '@sravni/design-system-icons'
 *
 * <PopularProfessions />
 * ```
 */
var PopularProfessions = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "PopularProfessions", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.086 3.413 2.94 6.27c-1.082.6-1.082 2.156 0 2.756l5.145 2.859c1.19.66 2.637.66 3.828 0l5.145-2.858c1.082-.601 1.082-2.156 0-2.757l-5.145-2.858a3.944 3.944 0 0 0-3.828 0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.992 10.167v3.27c0 .79.396 1.528 1.054 1.966l1.339.89a4.722 4.722 0 0 0 5.23 0l1.338-.89a2.36 2.36 0 0 0 1.054-1.966v-3.27", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { PopularProfessions };
//# sourceMappingURL=PopularProfessions.js.map
